import curry from "../lib/core/functional/curry";
import thunk from "../lib/core/functional/thunk";
import { retrieveJsonRequest } from "./utils";

const counterListeners = new Map();
const timeoutIds = new Map();

const emitData = curry(function emitData(data, cb) {
    cb(data);
});

const emitCounterResponse = curry(function emitCounterResponse(siteId, data) {
    const callbackList = counterListeners.get(siteId);
    callbackList.forEach(emitData(data));
    timeoutIds.set(
        siteId,
        setTimeout(() => {
            startCounterListener(siteId);
        }, 1e4)
    );
});

function startCounterListener(siteId) {
    getCounter(siteId).then(emitCounterResponse(siteId)).catch(console.error);
}

const stopCounterUpdates = thunk(function stopCounterUpdates(siteId, cb) {
    if (!counterListeners.has(siteId)) {
        return;
    }
    const callbackList = counterListeners.get(siteId);

    callbackList.delete(cb);
    if (callbackList.size === 0 && timeoutIds.has(siteId)) {
        clearTimeout(timeoutIds.get(siteId));
    }
});

export function getCounterUpdates(siteId, cb) {
    if (!counterListeners.has(siteId)) {
        counterListeners.set(siteId, new Set());
    }

    const callbackList = counterListeners.get(siteId);

    callbackList.add(cb);
    if (callbackList.size === 1) {
        startCounterListener(siteId);
    }

    return stopCounterUpdates(siteId, cb);
}

export function getCounter(siteId) {
    return retrieveJsonRequest(`/core/river/counter/${siteId}`, "GET");
}

export function clearCounter(siteId) {
    return retrieveJsonRequest(`/core/river/counter/${siteId}`, "DELETE");
}

export function getLastPublishedPosts(offset, limit, clearUnread) {
    return retrieveJsonRequest(
        `/core/river/?offset=${offset}&limit=${limit}&clear_unread=${clearUnread}`,
        "GET"
    );
}
